<template>
  <BaseViewComponent
    name="carousel"
    :is-preview="isPreview"
  >
    <div class="carousel-wrapper full-width flex justify-between items-center">
      <div class="container">
        <div class="title-h2">{{ pageData.carouselTitle }}</div>
      </div>
      <div class="relative-position arrows-wrapper">
        <div
          ref="carousel"
          class="carousel"
        >
          <div
            v-if="scrollLeftAvailable"
            class="arrow left flex items-center justify-center"
            @click="scrollLeft"
          >
            <q-icon
              name="far fa-arrow-left"
              size="24px"
            />
          </div>
          <div class="flex items no-wrap items-center">
            <div
              v-for="(item, index) in pageData.carouselItems"
              ref="carouselItem"
              :key="index"
              class="flex item overflow-hidden"
            >
              <div
                v-if="item.text || item.description"
                class="flex flex-1 column item-text"
              >
                <div class="title-h4 q-mb-sm">{{ item.title }}</div>
                <div class="text-p">{{ item.description }}</div>
              </div>
              <img
                v-if="getImage(item)"
                :src="getCompressImage(getImage(item))"
                class="image"
                width="100%"
              >
            </div>
          </div>
          <div
            v-if="scrollRightAvailable"
            class="arrow right flex items-center justify-center"
            @click="scrollRight"
          >
            <q-icon
              name="far fa-arrow-right"
              size="24px"
            />
          </div>
        </div>
      </div>
      <div class="dots q-mt-md justify-center items-center full-width flex gap-sm">
        <span
          v-for="dot in dots"
          :key="dot"
          :class="['dot', { 'filled': scrollPercent <= dot.max && scrollPercent >= dot.min }]"
        />
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import {
  ref,
  computed,
  onMounted,
  onUnmounted,
} from 'vue';
import getCompressImage from 'src/helpers/getCompressImage';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);

const dots = [{ min: 0, max: 24 }, { min: 25, max: 49 }, { min: 50, max: 74 }, { min: 75, max: 100 }];

const carouselItem = ref([]);
const carousel = ref(null);
const scrollTrigger = ref(1);
const scrollLeftAvailable = computed(
  () => scrollTrigger.value !== null && carousel.value && carousel.value.scrollLeft > 2,
);
const scrollRightAvailable = computed(
  () => scrollTrigger.value !== null && carousel.value && carousel.value.scrollLeft < (carousel.value.scrollWidth - carousel.value.clientWidth),
);
const scrollPercent = computed(() => {
  if (scrollTrigger.value !== null && carousel.value && carousel.value.scrollLeft) {
    return Math.ceil((carousel.value.scrollLeft / (carousel.value.scrollWidth - carousel.value.clientWidth)) * 100);
  }

  return 0;
});
const itemWidth = computed(() => carouselItem.value[0]?.clientWidth || 240);

function getImage(item) {
  return item.imagePreview || item.image;
}

function scrollLeft() {
  carousel.value.scrollLeft -= itemWidth.value;
}

function scrollRight() {
  carousel.value.scrollLeft += itemWidth.value;
}

function updateScroll() {
  scrollTrigger.value = scrollTrigger.value > 1 ? 1 : 2;
}

onMounted(() => {
  carousel.value.addEventListener('scroll', updateScroll);
});
onUnmounted(() => {
  carousel.value?.removeEventListener('scroll', updateScroll);
});
</script>

<style lang="scss" scoped>
</style>
